<template lang="pug" functional>
  .v-card__content(
    :class="{ 'v-card__content--full': props.full }")
    slot
</template>

<script>
export default {
  name: 'VCardContent',

  props: {
    full: Boolean
  }
}
</script>
